// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2RV8v","paramInput":"JobSimulator_paramInput__1CyCv","input":"JobSimulator_input__Hrzh3"};